export default __webpack_public_path__ + "static/media/speedsearching.dd2cc5d9.PNG";